// extracted by mini-css-extract-plugin
module.exports = {"competitionsEntry":"styles_competitionsEntry__BfzVu","heroContent":"styles_heroContent__R55Mz","body":"styles_body__lU3M0","pageContent":"styles_pageContent__yrj_s"};